import React, { useEffect, useState, useRef } from 'react';

import {
    Box,
    Stack,
    Typography,
    Paper,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    DialogActions,
    TextField,
    InputAdornment,
    IconButton,
    List,
    ListSubheader,
    ListItemButton,
    ListItemText,
    ListItem,
    Skeleton,
    FormControl,
    FormHelperText,
    MenuItem,
    InputLabel,
    Grid,
    styled,
    Chip,
    Button,
    Select
} from '@mui/material';

import { CommonIcons, icons } from '../../../../components/common/CommonIcons'
import { useSystemPrompt } from '../../../../hooks/useSystemPrompt';

import { useSystemUtils } from '../../../../hooks/useSystemUtils';

const StyledIcon = styled(Box)(({ theme }) => ({
    width: 20,
    height: 20,
    // opacity: 0.1,
    //   backgroundColor: "green",
    //   color: 'inherit',
    //   display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
}));


const StyledTitle = styled(Box)(({ theme }) => ({
    fontWeight: 800,
    fontSize: '1.0rem'
}))

const StyledSubTitle = styled(Box)(({ theme }) => ({
    fontWeight: 300,
    fontSize: '0.8rem'
}))

export default function CommonDialog(
    {
        open: openStatus,
        children,
        // t,
        configs,
        handleOnExit,
        handleOnSelect,
        tableVersionTypes,
        selectedOption
    }
) {

    const [open, setOpen] = useState(openStatus)

    const handleExit = (event, reason) => {

        // console.log('reason', reason)

        setOpen(false)

        if (handleOnExit) handleOnExit(event, reason)
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;

        handleOnSelect(value);
    };

    return (
        // <Box>

        <Dialog
            sx={{
                '& .MuiDialog-paper':
                    configs?.dialogStyle ?
                        configs.dialogStyle
                        :
                        {
                            // width: '80%', 
                            // minHeight: '90vh'
                            // height: '90vh'
                        }
            }}
            fullWidth={Boolean(true)}
            maxWidth="md"
            // TransitionProps={{ onEntering: handleEntering }}
            open={openStatus}
            // {...other}
            onClose={handleExit}
            // scroll='body'
            {...configs?.dialogProps ? configs.dialogProps : {}}
        >
            <DialogTitle>
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                >

                    {
                        configs?.RenderDialogTitle({ data: configs?.data })
                    }

                    {/* <FormControl
                        margin="dense"
                        size="small"
                        sx={{ mr: 7, maxWidth: 200 }}
                    >
                        <InputLabel>{('tableVersion')}</InputLabel>
                        <Select
                            label={('tableVersion')}
                            size="small"
                            sx={{ width: 200 }}
                            onChange={handleSelectChange}
                            value={selectedOption}
                        >
                            {
                                Object.values(tableVersionTypes).map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.display}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl> */}

                    <IconButton
                        aria-label="close"
                        onClick={handleExit}
                        sx={{
                            position: 'absolute',
                            right: 10,
                            top: 10,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CommonIcons name={icons.close} />
                    </IconButton>
                </Box>

            </DialogTitle>

            <DialogContent
                dividers
                // minheight="100%"
                sx={{
                    // backgroundColor: 'red',
                    pl: 0,
                    pr: 0,
                }}
            >

                {
                    configs?.RenderDialogContent({ data: configs?.data })
                }

            </DialogContent>
            {
                configs?.RenderDialogFooter &&
                <DialogActions>
                    {
                        configs?.RenderDialogFooter({ data: configs?.data })
                    }
                </DialogActions>

            }
            {/* <DialogActions>
                    <Button 
                        autoFocus 
                        // onClick={handleCancel}
                        onClick={() => {
                            handleOnCancel()
                        }}
                    >Cancel</Button>
                    <Button 
                        // onClick={handleOk}
                        onClick={() => {
                            handleOnConfirm()
                        }}
                    >Ok</Button>
                </DialogActions> */}
        </Dialog>

        // </Box>
    )
}